import stone0Icon from "planets/logic/logic-stone-0.svg"
import stone1Icon from "planets/logic/logic-stone-1.svg"
import stone2Icon from "planets/logic/logic-stone-2.svg"
import stone3Icon from "planets/logic/logic-stone-3.svg"
import stone4Icon from "planets/logic/logic-stone-4.svg"
import stone5Icon from "planets/logic/logic-stone-5.svg"
import stone6Icon from "planets/logic/logic-stone-6.svg"

export const stone0 = {
  icon: stone0Icon,
  width: "34px",
  height: "52px",
  top: "-20px",
  left: "310px"
}

export const stone1 = {
  icon: stone1Icon,
  width: "41px",
  height: "47px",
  top: "120px",
  left: "135px"
}

export const stone2 = {
  icon: stone2Icon,
  width: "39px",
  height: "52px",
  top: "255px",
  left: "60px"
}

export const stone3 = {
  icon: stone3Icon,
  width: "45px",
  height: "38px",
  top: "365px",
  left: "265px"
}

export const stone4 = {
  icon: stone4Icon,
  width: "47px",
  height: "50px",
  top: "485px",
  left: "50px"
}

export const stone5 = {
  icon: stone5Icon,
  width: "39px",
  height: "52px",
  top: "580px",
  left: "315px"
}

export const stone6 = {
  icon: stone6Icon,
  width: "45px",
  height: "38px",
  top: "650px",
  left: "55px"
}
